const styles = {
	container: {
		margin: { zero: "25px 0px", xs2: "50px 0px" },
		maxWidth: "100%",
		// width: { zero: "100%", sm1: "auto" },
		width:"100%",
		justifyContent: "center",
		alignItems: "center"
	}
}

export default styles
